import { render, staticRenderFns } from "./choosePurcharseGoods.vue?vue&type=template&id=223621b2&scoped=true"
import script from "./choosePurcharseGoods.vue?vue&type=script&lang=js"
export * from "./choosePurcharseGoods.vue?vue&type=script&lang=js"
import style0 from "./choosePurcharseGoods.vue?vue&type=style&index=0&id=223621b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223621b2",
  null
  
)

export default component.exports